import script from "./Archive.vue?vue&type=script&setup=true&lang=js"
export * from "./Archive.vue?vue&type=script&setup=true&lang=js"

import "./Archive.vue?vue&type=style&index=0&id=4a61c99c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a61c99c"]])

export default __exports__